import React from "react";
import { useTranslation } from "react-i18next";
import { useModalContext } from "common/contexts";
import { Button } from "components/bootstrap";
import { Markdown } from "components/common";
const EventNotes = ({ editable, securityEvent }) => {
  const { t } = useTranslation("enterprise_security_events");
  const { setModal, setEntity } = useModalContext();
  const openMDEditor = () => {
    setEntity(securityEvent);
    setModal("NOTES-EDITOR");
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Markdown, { text: securityEvent.notes || t("event_notes.no_notes") }), editable && /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", onClick: openMDEditor }, !securityEvent.notes ? t("event_notes.add") : t("event_notes.edit")));
};
export default EventNotes;
